<div class="h-full w-full p-3 overflow-y-scroll">
  <app-breadcrumb [items]="[{ label: 'Profile' }]"/>

  <div class="mt-3 rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
    <div class="flex items-center justify-between border-b border-stroke px-5 py-4 dark:border-strokedark sm:px-7.5">
      <h4 class="text-lg font-semibold text-gray-800 dark:text-gray-300">Profile</h4>
      @if (!editing()) {
        <button type="button" (click)="startEdit()"
          class="rounded-lg border border-gray-300 px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
          Edit
        </button>
      }
    </div>

    <div class="p-5 sm:p-7.5">
      <!-- Identity header -->
      <div class="flex items-center gap-4">
        <div class="flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-brand-100 text-xl font-semibold text-brand-700 dark:bg-brand-500/10 dark:text-brand-400">
          {{ initials }}
        </div>
        <div class="min-w-0">
          <p class="text-lg font-semibold text-gray-800 dark:text-white">{{ userStore.fullName() || '—' }}</p>
          <p class="text-sm text-gray-500 dark:text-gray-400">{{ userStore.email() || '—' }}</p>
          <div class="mt-1.5 flex flex-wrap gap-1.5">
            @for (role of userStore.roles(); track role) {
              <span class="rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-600 dark:bg-gray-800 dark:text-gray-300">{{ role }}</span>
            }
          </div>
        </div>
      </div>

      @if (saveError()) {
        <p class="mt-4 rounded-lg border border-red-200 bg-red-100 p-3 text-sm text-red-600">{{ saveError() }}</p>
      }

      <!-- Fields -->
      <div class="mt-6 grid grid-cols-1 gap-x-6 gap-y-5 sm:grid-cols-2">
        <div>
          <label class="mb-1 block text-xs text-gray-500 dark:text-gray-400">First Name</label>
          @if (editing()) {
            <input type="text" [(ngModel)]="firstName"
              class="h-10 w-full rounded-lg border border-gray-300 bg-transparent px-3 text-sm dark:border-gray-700 dark:text-white"/>
          } @else {
            <p class="text-sm text-gray-800 dark:text-gray-200">{{ userStore.firstName() || '—' }}</p>
          }
        </div>

        <div>
          <label class="mb-1 block text-xs text-gray-500 dark:text-gray-400">Last Name</label>
          @if (editing()) {
            <input type="text" [(ngModel)]="lastName"
              class="h-10 w-full rounded-lg border border-gray-300 bg-transparent px-3 text-sm dark:border-gray-700 dark:text-white"/>
          } @else {
            <p class="text-sm text-gray-800 dark:text-gray-200">{{ userStore.lastName() || '—' }}</p>
          }
        </div>

        <div>
          <label class="mb-1 block text-xs text-gray-500 dark:text-gray-400">Email</label>
          <p class="text-sm text-gray-800 dark:text-gray-200">{{ userStore.email() || '—' }}</p>
        </div>

        <div>
          <label class="mb-1 block text-xs text-gray-500 dark:text-gray-400">Phone</label>
          @if (editing()) {
            <input type="text" [(ngModel)]="cellPhone"
              class="h-10 w-full rounded-lg border border-gray-300 bg-transparent px-3 text-sm dark:border-gray-700 dark:text-white"/>
          } @else {
            <p class="text-sm text-gray-800 dark:text-gray-200">{{ userStore.cellPhone() || '—' }}</p>
          }
        </div>

        <div>
          <label class="mb-1 block text-xs text-gray-500 dark:text-gray-400">Country</label>
          @if (editing()) {
            <input type="text" [(ngModel)]="country"
              class="h-10 w-full rounded-lg border border-gray-300 bg-transparent px-3 text-sm dark:border-gray-700 dark:text-white"/>
          } @else {
            <p class="text-sm text-gray-800 dark:text-gray-200">{{ userStore.country() || '—' }}</p>
          }
        </div>

        <div>
          <label class="mb-1 block text-xs text-gray-500 dark:text-gray-400">Organization</label>
          <p class="text-sm text-gray-800 dark:text-gray-200">{{ organizationName }}</p>
        </div>
      </div>

      @if (editing()) {
        <div class="mt-6 flex items-center gap-3">
          <button type="button" (click)="save()" [disabled]="!canSave || saving()"
            class="flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50">
            @if (saving()) {
              <svg class="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/></svg>
              Saving...
            } @else {
              Save
            }
          </button>
          <button type="button" (click)="cancelEdit()" [disabled]="saving()"
            class="rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
            Cancel
          </button>
        </div>
      }
    </div>
  </div>
</div>
